import { Component, Input, OnInit } from '@angular/core';
import { SocialMediaEnum } from 'src/app/enums/socialMedia.enum';
import { LandingPage } from 'src/app/models/firebase/landing-page';
import { SocialMedia } from 'src/app/models/firebase/socialMedia';
import { AuthService } from 'src/app/service/auth/auth.service';
import { LandingPageService } from 'src/app/service/landing-page/landing-page.service';
import { SocialMediaService } from 'src/app/service/social-media/social-media.service';
import { IMAGES_RESOLUTIONS } from '../../utils/image-config/base/base/types';
import { filter, Subscription } from 'rxjs';
import { GetLanguageService } from 'src/app/service/get-language/get-language.service';
import { LandingPageBanner } from '../../models/firebase/landingPageBanner';
import { Router } from '@angular/router';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
    footerData: LandingPage;
    landingPageBanner: LandingPageBanner;
    @Input() backgroundColor: string;
    IMAGES_RESOLUTIONS = IMAGES_RESOLUTIONS;
    socialMediaArray: SocialMedia[] = [];
    socialMediaEnum = SocialMediaEnum;
    showNavigation: boolean = this.authService.getProjectIdFromHostname(window.location.hostname) === 'pineapplelabvc';

    languageSubscription: Subscription;
    constructor(
        private authService: AuthService,
        private router: Router,
        private socialMediaService: SocialMediaService,
        public getLanguageService: GetLanguageService,
        private landingPageService: LandingPageService) {}

    async ngOnInit(): Promise<void> {
        this.getSocialMedia();
        this.getLanguageService.language$.subscribe(lang => {
            this.loadData(lang);
        });
    }

    async getSocialMedia() {
        this.socialMediaArray = await this.socialMediaService.getSocialMedia(this.authService.projectId);
    }

    async loadData(lang: string) {
        this.footerData = await this.landingPageService.getLandingPageDataByLanguage(this.authService.projectId, lang);
        this.landingPageBanner = await this.landingPageService.getLandingPageBannerDataByLanguage(this.authService.projectId, lang);
    }

    goToLink(link: string) {
        if (link) {
            window.open(link, '_blank');
        }else{
            this.router.navigate(['/contact']);
        }

    }
}
